"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataGridNewLocalPersistentStorage = void 0;
const DataGridNewEmptyStorageData_1 = require("./types/DataGridNewEmptyStorageData");
const KEY = 'DataGridNew:ResizeStorage';
class DataGridNewLocalPersistentStorage {
    constructor(key) {
        this.key = `${KEY}:${key}"`;
    }
    save(payload) {
        localStorage.setItem(this.key, JSON.stringify(payload));
    }
    read() {
        try {
            return (JSON.parse(localStorage.getItem(this.key) || '""') ||
                DataGridNewEmptyStorageData_1.DATA_GRID_NEW_EMPTY_STORAGE_DATA);
        }
        catch (_a) {
            return DataGridNewEmptyStorageData_1.DATA_GRID_NEW_EMPTY_STORAGE_DATA;
        }
    }
}
exports.DataGridNewLocalPersistentStorage = DataGridNewLocalPersistentStorage;
//# sourceMappingURL=DataGridNewLocalPersistentStorage.js.map